import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { Button } from '../Button';
import { Tooltip } from '../Tooltip';
import TimesIcon from '@patternfly/react-icons/dist/js/icons/times-icon';
import styles from '@patternfly/react-styles/css/components/Chip/chip';
import { GenerateId } from '../../helpers/GenerateId/GenerateId';
import { getOUIAProps } from '../../helpers';
export var Chip =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Chip, _React$Component);

  function Chip(props) {
    var _this;

    _classCallCheck(this, Chip);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Chip).call(this, props));
    _this.span = React.createRef();

    _this.renderOverflowChip = function () {
      var _this$props = _this.props,
          children = _this$props.children,
          className = _this$props.className,
          onClick = _this$props.onClick,
          ouiaId = _this$props.ouiaId;
      var Component = _this.props.component;
      return React.createElement(Component, Object.assign({
        onClick: onClick,
        className: css(styles.chip, styles.modifiers.overflow, className)
      }, getOUIAProps('OverflowChip', ouiaId)), React.createElement("span", {
        className: css(styles.chipText)
      }, children));
    };

    _this.renderChip = function (randomId) {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          tooltipPosition = _this$props2.tooltipPosition;

      if (_this.state.isTooltipVisible) {
        return React.createElement(Tooltip, {
          position: tooltipPosition,
          content: children
        }, _this.renderInnerChip(randomId));
      }

      return _this.renderInnerChip(randomId);
    };

    _this.state = {
      isTooltipVisible: false
    };
    return _this;
  }

  _createClass(Chip, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isTooltipVisible: Boolean(this.span.current && this.span.current.offsetWidth < this.span.current.scrollWidth)
      });
    }
  }, {
    key: "renderInnerChip",
    value: function renderInnerChip(id) {
      var _this$props3 = this.props,
          children = _this$props3.children,
          className = _this$props3.className,
          onClick = _this$props3.onClick,
          closeBtnAriaLabel = _this$props3.closeBtnAriaLabel,
          isReadOnly = _this$props3.isReadOnly,
          component = _this$props3.component,
          ouiaId = _this$props3.ouiaId;
      var Component = component;
      return React.createElement(Component, Object.assign({
        className: css(styles.chip, className)
      }, this.state.isTooltipVisible && {
        tabIndex: 0
      }, getOUIAProps('Chip', ouiaId)), React.createElement("span", {
        ref: this.span,
        className: css(styles.chipText),
        id: id
      }, children), !isReadOnly && React.createElement(Button, {
        onClick: onClick,
        variant: "plain",
        "aria-label": closeBtnAriaLabel,
        id: "remove_".concat(id),
        "aria-labelledby": "remove_".concat(id, " ").concat(id)
      }, React.createElement(TimesIcon, {
        "aria-hidden": "true"
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var isOverflowChip = this.props.isOverflowChip;
      return React.createElement(GenerateId, null, function (randomId) {
        return isOverflowChip ? _this2.renderOverflowChip() : _this2.renderChip(_this2.props.id || randomId);
      });
    }
  }]);

  return Chip;
}(React.Component);
Chip.defaultProps = {
  closeBtnAriaLabel: 'close',
  className: '',
  isOverflowChip: false,
  isReadOnly: false,
  tooltipPosition: 'top',
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onClick: function onClick(_e) {
    return undefined;
  },
  component: 'div'
};